import { createConfigSection } from '../helpers'

export default {
    ...createConfigSection('api', {
        base: 'https://beheer-api.agressieregistratieoverheid.nl',
        requestTimeout: 2000
    }),

    ...createConfigSection('oidc', {
        authority: 'https://backend-nkylkc33ui6km.azurewebsites.net',
        post_logout_redirect_uri: 'https://beheer.agressieregistratieoverheid.nl'
    })
}
